module.exports = __webpack_public_path__ + "front/img/m_top.182668a0.jpg";